import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    users: [],
    dataValid: false
  },
  reducers: {
    setUsers(state, action) {
      console.count("userSlice: setUsers");
      if (!action || !action.payload || !action.payload.users) {
        state.users = [];    
      } else {
        state.users = action.payload.users;
      }
    },
    setUser(state, action) {
      if (!action || !action.payload || !!action.payload.user) return;
      state.users = state.users
        .filter((item) => item.id !== action.payload.user.id)
        .push(action.payload.user);
    },
    removeUser(state, action) {
      if (!action || !action.payload || !!action.payload.user) return;
      state.users = state.users.filter((item) => item.id !== action.payload.user.id);
    },
    invalidateData(state, action) {
      state.dataValid = false;
    }
  },
});

export const userActions = userSlice.actions;

export default userSlice;